import * as consts from '../../../modules/data/base/consts'
import { UTILS } from '../../../modules/utils'

/**
 * 处理首页相关逻辑数据
 */
var USER_DATA_MANAGER = {
	/**
	 * 获取用户信息
	 * @param {Object} data
	 */
	getUserBaseInfoByData(data) {
		var tempData = Object.assign({}, data);
		var birthInfo = UTILS.getBirthdayInfoByTimeStamp(data.birthday);
		var endInfo = UTILS.getBirthdayInfoByTimeStamp(data.typetime);
		var endTimeArr = endInfo.date.split(' ');
		var resultData = Object.assign({
			birthdayStr: birthInfo.date,
			vipEndTimeStr: endTimeArr[0],
			constellation: birthInfo.constellation,
			firstL: UTILS.getFirstLetter(tempData.f_name),
		}, tempData);
		console.log('getUserBaseInfoByData-------', birthInfo, endTimeArr, resultData)
		return resultData;
	},
	/**
	 * 获取用户先天天赋
	 * @param {Object} data
	 */
	getUserBaseTalentInfoByData(data) {
		var categories = [], series = [];
		var tempArr = [].concat(data.info);
		var newArr = [tempArr[0]];
			newArr = newArr.concat(tempArr.slice(1).reverse());
		newArr.forEach(element => {
			categories.push({
				name: element.name, max: 100
			});
			series.push(element.score);
		});
		console.log('getUserBaseTalentInfoByData-----', categories, series)
		return {
			categories: categories,
			series: series
		}
	},
	/**
	 * 处理当前测算用户的首页数据
	 */
	getHomePageDataByData(data) {
		var resultData = {}, 
			tempData = Object.assign({}, data);
		var cowIndex = consts.CONST_COW_WORD.indexOf(tempData.title),
			fMonthData = tempData.f.pay.info.minfo ? USER_DATA_MANAGER.getMonthDataByData(tempData.f.pay.info.minfo) : {},
			sMonthData = tempData.s.pay.info.minfo ? USER_DATA_MANAGER.getMonthDataByData(tempData.s.pay.info.minfo) : {};
		resultData = Object.assign({
			scoreArr: parseInt(tempData.score).toString().split(''),
			titleClass: cowIndex >= 0 ? consts.CONST_COW_CLASS[cowIndex] : '',
			fMonthList: fMonthData && fMonthData.mList ? fMonthData.mList : [],
			fMCategories: fMonthData && fMonthData.mCategories ? fMonthData.mCategories : [],
			fMSeries: fMonthData && fMonthData.mSeries ? fMonthData.mSeries : [],
			sMonthList: sMonthData && sMonthData.mList ? sMonthData.mList : [],
			sMCategories: sMonthData && sMonthData.mCategories ? sMonthData.mCategories : [],
			sMSeries: sMonthData && sMonthData.mSeries ? sMonthData.mSeries : []
		}, tempData);
		// console.error('getHomePageDataByData--------', resultData)
		return resultData;
	},
	/**
	 * 处理minfo
	 * @param {Object} data
	 */
	getMonthDataByData(data) {
		var monthList = [], tempList = [], 
			categories = [], series = [];
		data.forEach(element => {
			tempList.push(element);
			var temp = [].concat(tempList);
			if(tempList.length == 3) {
				monthList.push(temp);
				tempList.splice(0);
			}
			var month = element.m.indexOf('22年') != -1 ? element.m.replace('22年', '') : element.m;
			categories.push(month+'月');
			series.push(parseInt(element.score));
		});
		// series = [{ name: '运势', data: scoreArr, color: '#E02020' }];
		// console.error('getMonthDataByData-----', monthList, categories, scoreArr)
		return {
			mList: monthList, mCategories: categories, mSeries: series
		}
	},
	/**
	 * 获取我的列表数据
	 * @param {Object} data
	 */
	getMyUserListDataByData(data) {
		var len = data.length, resultList = [];
		for(var i = 0; i < len; i++) {
			var newData = Object.assign({
				firstL: UTILS.getFirstLetter(data[i].f_name),
			}, data[i]);
			resultList.push(newData);
		}
		console.log('getMyUserListDataByData----', resultList)
		return resultList;
	},
	/**
	 * 获取我的用户列表数据
	 * @param {Object} data
	 */
	getMyUserDataByData(data) {
		var resultData = Object.assign({
			f_type: 0,
			firstL: UTILS.getFirstLetter(data.f_name),
		}, data);
		return resultData;
	}
}

export {
    USER_DATA_MANAGER
}